"use strict";
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var typestyle_1 = require("typestyle");
var constants_1 = require("../../../constants");
var generic_1 = require("../../generic");
var is_default = function (evaluation, estimates) {
    return (evaluation.freq_low == estimates.freq_low &&
        evaluation.freq_mid == estimates.freq_mid &&
        evaluation.freq_high == estimates.freq_high &&
        evaluation.cons_low == estimates.cons_low &&
        evaluation.cons_mid == estimates.cons_mid &&
        evaluation.cons_high == estimates.cons_high);
};
var EvaluationCell = function (props) {
    var icons = [];
    var nonDefaultClass = '';
    var grossFAClass = 'EvaluationCell__Gross';
    var presentFAClass = 'EvaluationCell__Present';
    var nettFAClass = 'EvaluationCell__Nett';
    constants_1.EvaluationTypeChoices.toList().map(function (etype) {
        var evaluation = props.evaluationByEType(props.evaluations, etype);
        var selected_cell = evaluation && evaluation.cell ? evaluation.cell.id : null;
        var evaluation_type = evaluation ? evaluation.evaluation_type : null;
        if (selected_cell && evaluation_type) {
            if (selected_cell == props.cell.id) {
                var default_estimate = is_default(evaluation, props.estimates) || !props.explicit_evaluation;
                if (default_estimate) {
                    nonDefaultClass = '';
                }
                else {
                    nonDefaultClass = 'EvaluationCell__NonDefault';
                }
                switch (evaluation_type) {
                    case constants_1.EvaluationTypeChoices.GROSS:
                        icons.push(React.createElement(generic_1.Icon, { key: Math.random(), name: generic_1.Icons.circle, prefix: "far", transform: "grow-10", className: (0, typestyle_1.classes)(grossFAClass, nonDefaultClass) }));
                        break;
                    case constants_1.EvaluationTypeChoices.PRESENT:
                        icons.push(React.createElement(generic_1.Icon, { key: Math.random(), name: generic_1.Icons.circle, prefix: "far", className: (0, typestyle_1.classes)(presentFAClass, nonDefaultClass) }));
                        break;
                    case constants_1.EvaluationTypeChoices.NETT:
                        icons.push(React.createElement(generic_1.Icon, { key: Math.random(), name: generic_1.Icons.circle, prefix: "far", transform: "shrink-8", className: (0, typestyle_1.classes)(nettFAClass, nonDefaultClass) }));
                        break;
                }
            }
        }
    });
    var tdBase = "EvaluationCell";
    var tdClassName = (0, typestyle_1.classes)(tdBase, props.cell.color_display);
    return (React.createElement("td", { onClick: props.clickHandler.bind(_this), className: tdClassName, title: props.cell.value.toString() }, icons.length > 0 &&
        React.createElement("span", { className: (0, typestyle_1.classes)("fa-layers") }, icons)));
};
exports.default = EvaluationCell;
